import { render } from "./SInput.vue?vue&type=template&id=45d2741c&ts=true"
import script from "./SInput.vue?vue&type=script&lang=ts"
export * from "./SInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
